module.exports = __webpack_public_path__ + "img/logo_dark.a9910e3a.png";